import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-process-rolled-throughput-yield-calculator',
  templateUrl: './process-rolled-throughput-yield-calculator.component.html',
  styleUrls: ['./process-rolled-throughput-yield-calculator.component.css']
})
export class ProcessRolledThroughputYieldCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    value4: new FormControl(''),
    value5: new FormControl(''),
    } )

  } 
  dpu(n3,n4){
    var dpuVal=n3/n4;
    var dpuValpercent= dpuVal*100;
    var dpuValsimple= dpuValpercent.toFixed(2);
    return dpuValsimple ;
    }
  dpi(n3,n4,n5){
    var dpiVal=(n3/n4)/n5;
    var dpiValPercent= dpiVal*100;
    var dpiValSimple= dpiValPercent.toFixed(2);
    return dpiValSimple ; 
    }
  rty(n1,n2,n3,n4,n5){
    var dpiValu=(n3/n4)/n5;
    var rtyVal1=(1-dpiValu);
    var rtyVal2=Math.pow(rtyVal1,n1);
    var rtyVal=Math.pow(rtyVal2,n2);
    var rtyValPercent= rtyVal*100;
    var rtyValSimple= rtyValPercent.toFixed(2);
    return rtyValSimple ; 
    }
}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/process-rolled-throughput-yield-calculator/process-rolled-throughput-yield-calculator.component.ts